import { render, staticRenderFns } from "./colors_dragable.vue?vue&type=template&id=5df0143a&"
import script from "./colors_dragable.vue?vue&type=script&lang=js&"
export * from "./colors_dragable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports